export default __webpack_public_path__ + "static/media/360.79b8c66e.jpg";